import { render, staticRenderFns } from "./korvaa-suorite.vue?vue&type=template&id=a700bd4a&scoped=true&"
import script from "./korvaa-suorite.vue?vue&type=script&lang=ts&"
export * from "./korvaa-suorite.vue?vue&type=script&lang=ts&"
import style0 from "./korvaa-suorite.vue?vue&type=style&index=0&id=a700bd4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a700bd4a",
  null
  
)

export default component.exports